// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"RatioImage_wrapper__37XMa","image":"RatioImage_image__15139"};